<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <gift-table></gift-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import giftTable from './GiftTable.vue'

  export default {
    name: 'gift',
    components: {giftTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/gift/Gift.vue